import axios from 'axios';
import { API } from './env';

const API_BASE_URL = API;

class CompanySignupApi {
  /**
   * Validate if company exists in the system
   * @param {string} companyId - The company ID to validate
   * @returns {Promise} - Promise with validation result
   */
  static validateCompany = async (companyId) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/company-signup/validate`, {
        companyId
      });

      return {
        success: true,
        exists: response.data.exists,
        message: response.data.message
      };
    } catch (error) {
      console.log("error!!");
      console.log(error);
      if (error.response && error.response.status === 404) {
        return {
          success: false,
          exists: false,
          errorMessage: error.response.data.message || 'מספר הלקוח לא קיים במערכת. אנא פנה לשירות לקוחות'
        };
      }

      console.error('Error validating company:', error);
      return {
        success: false,
        exists: false,
        errorMessage: 'שגיאה בבדיקת מספר הלקוח. אנא נסה שוב'
      };
    }
  };

  /**
   * Validate if company exists and contact phone matches
   * @param {string} companyId - The company ID to validate
   * @param {string} contactPhone - The contact phone to validate
   * @returns {Promise} - Promise with validation result
   */
  static validateCompanyAndPhone = async (companyId, contactPhone) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/company-signup/validate-phone`, {
        companyId,
        contactPhone
      });

      return {
        success: true,
        valid: response.data.valid,
        message: response.data.message
      };
    } catch (error) {
      console.log("error in validateCompanyAndPhone!!");
      console.log(error);
      if (error.response && error.response.data) {
        return {
          success: false,
          valid: false,
          errorMessage: error.response.data.message || error.response.data || 'שגיאה בבדיקת פרטי החברה'
        };
      }

      console.error('Error validating company and phone:', error);
      return {
        success: false,
        valid: false,
        errorMessage: 'שגיאה בבדיקת פרטי החברה. אנא נסה שוב'
      };
    }
  };

  /**
   * Get company signup data including pricing configuration
   * @param {string} companyId - The company ID
   * @returns {Promise} - Promise with company data
   */
  static getCompanySignupData = async (companyId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/company-signup/${companyId}`);
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return {
          success: false,
          errorMessage: 'מספר הלקוח לא קיים במערכת'
        };
      }
      
      console.error('Error fetching company signup data:', error);
      return {
        success: false,
        errorMessage: 'שגיאה בטעינת נתוני החברה. אנא נסה שוב'
      };
    }
  };

  /**
   * Update company approval status and contact details if changed
   * @param {string} companyId - The company ID
   * @param {Object} updateData - Optional data to update (companyName, contactName, contactEmail)
   * @returns {Promise} - Promise with update result
   */
  static approveTerms = async (companyId, updateData = {}) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/company-signup/${companyId}/approve`, updateData);

      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return {
          success: false,
          errorMessage: 'מספר הלקוח לא קיים במערכת'
        };
      }

      console.error('Error approving terms:', error);
      return {
        success: false,
        errorMessage: 'שגיאה באישור התנאים. אנא נסה שוב'
      };
    }
  };
}

export default CompanySignupApi;
